<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.smAndDown, 'py-5 px-4': $vuetify.breakpoint.mdAndUp}" width="933">
        <v-icon class="modal-close" @click.native="CLOSE_MODAL('employee_study_modal')">close</v-icon>
        <v-card-title class="display-1 mb-4">{{ user_study_stats.course_name }}</v-card-title>
        <v-layout :class="{'my-3': $vuetify.breakpoint.smAndDown, 'my-5': $vuetify.breakpoint.mdAndUp}">
            <div :class="{'subheading': $vuetify.breakpoint.smAndDown, 'title': $vuetify.breakpoint.mdAndUp}">{{ user_study_stats.user_name }}</div>
        </v-layout>
        <v-layout wrap justify-space-between align-content-space-between>
            <v-flex md5 sm8 xs12>
                <v-layout column>
                    <v-flex>
                        <labelTopic class="section-label--white-shadow" :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp}">{{ user_study_stats.status }}</labelTopic>
                        <labelTopic v-if="user_study_stats.required_course" class="section-label--red">{{$t("Обязательный курс")}}</labelTopic>
                    </v-flex>
                    <v-layout class="grey-text mt-3">
                        <svg v-svg
                             symbol="series"
                             class="study__icon study__icon-grey"
                             role="presentation"
                        />
                        <v-flex>
                            <span>{{ user_study_stats.course_series_name }}</span>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>
            <v-flex md3 sm4 xs12
                    :class="{'mt-3': $vuetify.breakpoint.xs}"
            >
                <v-layout class="justify-start align-center">
                    <div
                        class="mx-2"
                        v-html="$t('Пройдено разделов {lineBreak} {lessonsPassed} из {lessonsTotal}', {
                        'lineBreak': '<br>',
                        'lessonsPassed': user_study_stats.passed_lessons,
                        'lessonsTotal': user_study_stats.all_lessons,
                      })"
                    />
                    <v-progress-circular
                        :rotate="-90"
                        :size="64"
                        :width="6"
                        :value="percent(user_study_stats.all_lessons, user_study_stats.passed_lessons)"
                        :color="false ? '#e2173d' :'#44b69e'"
                    >
                        {{ percent(user_study_stats.all_lessons, user_study_stats.passed_lessons) }}%
                    </v-progress-circular>
                </v-layout>
            </v-flex>
            <v-flex md4 sm12 :class="{'mt-3': $vuetify.breakpoint.smAndDown, 'pl-4': $vuetify.breakpoint.mdAndUp}">
                <v-layout column fill-height>
                    <v-layout>
                        <svg v-svg
                             symbol="schedule"
                             class="study__icon study__icon-grey"
                             role="presentation"
                        />
                        <v-flex>{{ user_study_stats.course_date_start || '' }} - {{ user_study_stats.course_date_finish || '' }}</v-flex>
                    </v-layout>
                    <!-- <v-flex class="mt-3">
                        <span class="grey-text mr-2">{{$t("Назначение")}}:</span><span>{{ user_study_stats.assignment }}</span>
                    </v-flex> -->
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout class="my-5 wrap">
            <v-flex class="xs12 mb-3" :class="{'title': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}">{{$t("Итоговый тест")}}</v-flex>
            <v-flex class="md3 sm6 xs6 text-xs-center">
                <div class="background-dark borders pa-2 white--text">{{$t("Вопросов в тесте")}}</div>
                <div class="borders pa-2">{{ user_study_stats.count_questions }}</div>
            </v-flex>
            <v-flex class="md3 sm6 xs6 text-xs-center">
                <div class="background-dark borders pa-2 white--text">{{$t("Проходной балл")}}</div>
                <div class="borders pa-2">{{ user_study_stats.points_min }}</div>
            </v-flex>
            <v-flex class="md3 sm6 xs6 text-xs-center">
                <div class="background-dark borders pa-2 white--text">{{$t("Ограничение по времени")}}</div>
                <div class="borders pa-2">{{ user_study_stats.time_limit }}</div>
            </v-flex>
            <v-flex class="md3 sm6 xs6 text-xs-center">
                <div class="background-dark borders pa-2 white--text">{{$t("Результат тестирования")}}</div>
                <div class="borders pa-2">{{ user_study_stats.test_result }}</div>
            </v-flex>
            <v-flex class="md3 sm6 xs6 text-xs-center">
                <div class="background-dark borders pa-2 white--text">{{$t("Количество попыток")}}</div>
                <div class="borders pa-2">{{ user_study_stats.attempts_count }}</div>
            </v-flex>
            <v-flex class="md3 sm6 xs6 text-xs-center">
                <div class="background-dark borders pa-2 white--text">{{$t("Максимальный балл")}}</div>
                <div class="borders pa-2">{{ user_study_stats.points_max }}</div>
            </v-flex>
            <v-flex class="md3 sm6 xs6 text-xs-center">
                <div class="background-dark borders pa-2 white--text">{{$t("Дата завершения")}}</div>
                <div class="borders pa-2">{{ user_study_stats.date_finish || '-' }}</div>
            </v-flex>
            <v-flex class="md3 sm6 xs6 text-xs-center">
                <div class="background-dark borders pa-2 white--text">{{$t("Просрочено дней")}}</div>
                <div class="borders pa-2">{{ user_study_stats.expired_days }}</div>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between>
            <v-flex xs12 md6 :class="{'mb-4': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}">
                <v-layout column>
                    <div class="mb-4" :class="{'title': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}">{{$t("История смены статусов")}}</div>
                    <v-layout class="background-light pa-3 justify-space-between">
                        <v-flex>{{$t("Новый")}}</v-flex>
                        <v-flex text-xs-right>{{ user_study_stats.status_new_date }}
                            <!-- <span class="grey-text ml-2">{{ get_time(status.date) }}</span> -->
                        </v-flex>
                    </v-layout>
                    <v-layout class="pa-3 justify-space-between">
                        <v-flex>{{$t("Идет обучение")}}</v-flex>
                        <v-flex text-xs-right>{{ user_study_stats.status_current_date }}
                            <!-- <span class="grey-text ml-2">{{ get_time(status.date) }}</span> -->
                        </v-flex>
                    </v-layout>
                    <v-layout class="background-light pa-3 justify-space-between">
                        <v-flex>{{$t("Завершен")}}</v-flex>
                        <v-flex text-xs-right>{{ user_study_stats.status_finished_date }}
                            <!-- <span class="grey-text ml-2">{{ get_time(status.date) }}</span> -->
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>
            <v-flex xs12 md6>
                <v-layout column>
                    <div class="mb-4" :class="{'title': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}">{{$t("Попытки сдать тест")}}</div>
                    <v-layout v-for="(attemp, i) in user_study_stats.test_history" :key="i" :class="{'background-light': !(i%2)}"
                              class="pa-3 justify-space-between"
                    >
                        <v-flex>{{$t("Результат")}}: {{ attemp.points }}</v-flex>
                        <v-flex>{{$t("Время")}}: {{ attemp.duration }}</v-flex>
                        <v-flex text-xs-right>{{ attemp.date.split(' ')[0] }} <span class="grey-text">{{ attemp.date.split(' ')[1] }}</span> </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
import labelTopic from '@/components/ui/labels/label_topic.vue';
import dataTable from './../Employee_study_table';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);
export default {
  components: {
    labelTopic,
    dataTable,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('employee_study/modal', [
      'status_changes',
      'test_attemps',
      'user_study_stats',
    ]),
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  mounted() {
    this.user_course_detail();
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapMutations('employee_study', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('contact/requests', [
      'ask_question',
    ]),
    ...mapActions('employee_study/modal', [
      'user_course_detail',
    ]),
    percent(total, value) {
      if (value > 0) {
        if (value<total) {
          return Math.round((value/total)*100);
        } else return 100;
      } else return 0;
    },
    get_date(date) {
      return new dayjs(parseInt(date)).utc().format('DD.MM.YYYY');
    },
    get_short_date(date) {
      return new dayjs(parseInt(date)).utc().format('DD.MM');
    },
    get_time(date) {
      return new dayjs(parseInt(date)).utc().format('HH.mm');
    },
  },


};
</script>
